import {NgModule} from '@angular/core';
import {FloorFormComponent} from './floor-form.component';
import {FloorDatatableComponent} from './floor-datatable.component';
import {FloorService} from './floor.service';
import {SharedModule} from '../shared/shared.module';
import {TabsModule} from 'ngx-bootstrap';
import {RoomModule} from '../room/room.module';
import {DrawingModule} from '../drawing/drawing.module';

@NgModule({
  declarations: [
    FloorDatatableComponent,
    FloorFormComponent
  ],
  exports: [
    FloorDatatableComponent,
    FloorFormComponent
  ],
  imports: [
    SharedModule,
    TabsModule.forRoot(),
    RoomModule,
    DrawingModule
  ],
  providers: [
    FloorService
  ]
})
export class FloorModule {

}



// WEBPACK FOOTER //
// /var/jenkins_home/workspace/brands-compart-portal-frontend/checkout/src/app/components/floor/floor.module.ts